import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"

import { statusBadgeColor } from "src/utils/status_badge_color_helper"
import { humanize } from "src/utils/string_helpers"

const StatusBadge = ({ status }) => {
  if (!status) return null
  const displayText = humanize(status)
  const badgeColor = statusBadgeColor(displayText)
  return <Badge color={badgeColor} text={displayText} />
}

StatusBadge.propTypes = {
  status: PropTypes.string,
}

export default StatusBadge
